module.exports = __webpack_public_path__ + "img/horizontal_5_1_9005.b298d660.png";